<template>
    <div id="app">
        <header>
            <div class="geact2-title">
                <span style="font-size: 1.8rem;font-weight: bold; color: #555"><img style="display:inline-block; width: 30px; padding-right: 8px" src="/cell.png" /><a style="text-decoration-line: none; color: #09B07A;" href="/">Cell BLAST</a><sub style="font-size: 12px; color: #fff; font-weight: bold; background-color: #78C269; padding: 3px 5px; margin-left: 5px; border-radius: 3px;">Alpha v0.5.0</sub></span></span>
            </div>
            <div id="nav">
                <div style="display: flex;font-weight: bold;">
                    <div class="nav-item1">
                        <router-link class="main-nav-link" to="/">Home</router-link>
                    </div>
                    <div class="nav-item1">
                        <router-link class="main-nav-link" to="/download">Download</router-link>
                    </div>
                    <div class="nav-item1">
                        <router-link class="main-nav-link" to="/FAQs">FAQs</router-link>
                    </div>
                    <div class="nav-item1">
                        <router-link class="main-nav-link" to="/contact">Contact</router-link>
                    </div>
                </div>
            </div>
        </header>
        <keep-alive>
            <router-view />
        </keep-alive>
        <footer id="footer">
            <p id="footer-copyright" style="text-align: center; font-size: 1.1rem; padding: 0.4rem 0;">
                Copyright © 2019, <a href="http://www.gao-lab.org/index.php/en/home/" target="_blank">GaoLab</a> all rights reserved.
            </p>
        </footer>
    </div>
</template>
<script>

export default {
    data: function data() {
        return {

        }
    },
    methods: {
        saveToken: function(token) {
            window.localStorage['geact2-jwt-token'] = token;
        },
        getToken: function() {
            return window.localStorage['geact2-jwt-token'];
        },
        isLoggedIn: function() {
            var token = this.getToken();
            if (token) {
                var payload = JSON.parse(window.atob(token.split('.')[1]));
                if (payload.exp >= Date.now() / 1000) {
                    return true
                } else {
                    this.logout()
                    return false
                }
            } else {
                return false;
            }
        },
        currentUser: function() {
            if (this.isLoggedIn()) {
                var token = this.getToken();
                var payload = JSON.parse(window.atob(token.split('.')[1]));
                return {
                    email: payload.email,
                    name: payload.name
                };
            }
        },
        logout: function() {
            window.localStorage.removeItem('geact2-jwt-token');
            window.location.replace('/');
        }
    }
}
</script>
<style>
html,
body {
    font-family: 'Open Sans', sans-serif;
}

body {
    font-family: 'Open Sans', sans-serif;
}

#app {
    font-family: 'Open Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #09B07A;
    display: flex;
    flex-direction: column;
    line-height: 1.5;
    transition: .4s;
    font-size: 0.8rem;
    max-width: 1400px;
    margin: 0 auto;
}

#md p {
    color: #000;
    font-size: 1.1rem;
    text-align: left;
    line-height: 1.8;
    text-align:justify 
}

#md li {
    color: #000;
    font-size: 1.1rem;
    text-align: left;
    line-height: 1.8;
    text-align:justify 
}

#md ul {
    padding-left: 16px
}
#md h1 {
   text-align: center;
   color: #09B07A; 
}

#md h2 {
    font-size: 1.6rem;
    margin-bottom: 0;
}

img {
        width: 100%;
}

[v-cloak] {
    display: none;
}

header {
    display: flex;
    flex-flow: row wrap;
    padding: 0px 0px;
}

#nav {
    display: flex;
    flex: 1;
    justify-content: flex-end;
}

.geact2-title {
    font-size: 1.8rem;
    font-weight: bold;
    align-items: center;
    display: flex;
}

.nav-item {
    flex: 0 0 auto;
    padding: 10px 5px;
}

.nav-item1 {
    flex: 0 0 auto;
    padding: 10px 15px;
}

.login {
    display: inline-flex;
    text-decoration-line: none;
    font-size: 14px;
    padding: 4px 18px;
    font-weight: bold;
    color: #2EC292;
    border: 1px solid #2EC292;
    border-radius: 4px;
}

.create {
    display: inline-flex;
    text-decoration-line: none;
    font-size: 14px;
    padding: 4px 18px;
    font-weight: bold;
    color: #fff;
    background-color: #2EC292;
    border: 1px solid #2EC292;
    border-radius: 4px;
}

.create:hover {
    background-color: #09B07A;
    border: 1px solid #09B07A;
    /*color: #09B07A;*/
}

.login:hover {
    border-color: #09B07A;
    color: #09B07A;
}

.main-nav-link {
    color: #555;
    font-size: 1.2rem;
    text-decoration: none;
    line-height: 35px;
    /*opacity: 0.9;*/
    -webkit-transition: .1s;
    transition: .1s;
    display: inline-block;
}

.main-nav-link:hover {
    opacity: 1;
    color: #09B07A;
    /*transform: scale(1.05);*/
}

.nav-active {
    opacity: 1;
    color: #c33;
    font-weight: 700;
}

.item {
    display: inline-block;
}

.router-link-exact-active {
    color: #09B07A;
    border-bottom: 2px solid #09B07A;
}

text {
    fill: #000;
    pointer-events: none;
}

line {
    stroke: #c1c1c1;
    stroke-width: 1.5px;
    pointer-events: all;
}

circle {
    pointer-events: all;
    stroke: #666;
    stroke-width: 1px;
    stroke-opacity: 1;
    cursor: pointer;
}

a {
    /*border-bottom: 1px dashed #09B07A;*/
    color: #09B07A;
    text-decoration: none;
}

a:hover {
    border-bottom: 1px solid #09B07A;
}

button {
    outline: none
}
</style>